import styled from "styled-components"
import { Link as RouterLink } from "react-router-dom"
import { breakpoints } from "@theguarantors/ui-kit-v2/dist/design-system/breakpoints"
import { Box } from "@theguarantors/ui-kit-v2/dist/design-system/typography"
import { theme } from "@theguarantors/ui-kit-v2/dist/design-system"

import { SubmitButton } from "../styles"

interface SectionProps {
  margin?: string
}
export const Section = styled(Box)<SectionProps>`
  margin: ${(props: SectionProps) => props.margin || "3.2rem 0"};
  max-width: 124rem;
  display: flex;
  flex-direction: column;
`

export const Main = styled.main`
  position: relative;
  z-index: ${theme.zIndeces.content};
  padding: 12rem 2rem 0 2rem;
  margin: 0 auto;
  max-width: 124rem;
  display: flex;
  flex-direction: column;
`
interface LinkProps {
  color?: string
  textDecoration?: string
  fontWeight?: string
}
export const Link = styled(RouterLink)<LinkProps>`
  text-decoration: ${(props: LinkProps) => props.textDecoration || "none"};
  color: ${(props: LinkProps) => props.color || theme.colors.ultramarine};
  font-weight: ${(props: LinkProps) => props.fontWeight || "bold"};
`

export const GetStartedButton = styled(SubmitButton)``

interface CardProps {
  color?: string
  gap?: string
}
export const Card = styled.article<CardProps>`
  background-color: white;
  border-radius: 1rem;
  box-shadow: 0 2.2rem 2.4rem 0 rgba(148, 169, 200, 0.31);
  padding: 3.2rem 2.4rem;
  margin-bottom: 3rem;

  li {
    color: ${(props: CardProps) => props.color || "#022e5a"};
    list-style-type: none;
    padding: 0.5rem 0;
    letter-spacing: -0.01rem;
    margin: ${(props: CardProps) => `0 0 ${props.gap} 0` || "0"};
  }

  ul {
    padding-left: 0;
    span {
      padding-right: 0.5rem;
    }
  }

  @media (min-width: ${breakpoints[2]}) {
    background: transparent;
    box-shadow: none;
    margin: 3.2rem 3.2rem 0;
    padding-bottom: 0;
  }

  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
`

export interface NavSectionProps {
  newGetStartedPageFeatureFlag?: boolean
}
export const NavSection = styled.article<NavSectionProps>`
  ul {
    list-style-type: none;
    padding: 0;
  }

  a {
    color: white;
  }

  li {
    font-size: 1.2rem;
    padding: 0.5rem 0;
  }

  ${(props: NavSectionProps) =>
    props.newGetStartedPageFeatureFlag
      ? `
    h3, li {
      font-family: ${theme.fonts.acid}; 
      font-weight: 400;
    }
    li {
      margin-bottom: 1rem;
    }
  `
      : `
    h3 {
      font-family: ${theme.fonts.bold};
      font-size: 1.6rem;
      word-break: normal;
      margin-bottom: 1.2rem;
      font-weight: 900;
    }

    li {
      font-family: ${theme.fonts.regular};
    }
  `}
`

export const SocialLinks = styled.div`
  display: flex;
  svg {
    margin-right: 2.5rem;
  }
`

export const NavLinks = styled.nav`
  ul {
    list-style-type: none;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
  }

  li {
    padding-right: 1.5rem;
  }
`
